import { useSelector } from 'react-redux';
import { Trans } from 'react-i18next';

import { userPermissions, urlApplicationRoot } from '/business/shared/util/Statics';

import LinkButton from '/shared/components/widgets/button/LinkButton';

import getAuthRuleSelector from '/business/shared/state/selectors/auth/getAuthRuleSelector';

import HeaderDashboardTabs from './HeaderDashboardTabs';
import HeaderDashboardSubNavMenu from './HeaderDashboardSubNavMenu';
import HeaderDashboardWelcome from './HeaderDashboardWelcome';

import StyledHeaderDashboard from '/business/shared/components/widgets/header/__styled__/StyledHeaderDashboard';
import StyledHeaderCreateButton from '/business/shared/components/widgets/header/__styled__/StyledHeaderCreateButton';
import UploadPlus from '/business/shared/images/icons/icon-upload-plus-green.svg';
import type { RootState } from '/business/shared/state/store';

function HeaderDashboard() {
  const createApplicationAuth = useSelector((state: RootState) =>
    getAuthRuleSelector(state, userPermissions.CREATE_APPLICATION),
  );

  return (
    <StyledHeaderDashboard>
      <div>
        <HeaderDashboardSubNavMenu />
        <StyledHeaderCreateButton>
          {createApplicationAuth && (
            <LinkButton
              $primary
              $outline
              $thinner
              $inverted
              $stretch
              $iconAfter={UploadPlus}
              to={`/create-${urlApplicationRoot}`}
            >
              {/* @i18n: Create a new carbon review */}
              <Trans i18nKey="business:Dashboard.buttonCreateApplication" />
            </LinkButton>
          )}
        </StyledHeaderCreateButton>
      </div>
      <HeaderDashboardWelcome />
      <HeaderDashboardTabs />
    </StyledHeaderDashboard>
  );
}

export default HeaderDashboard;
